export default __webpack_public_path__ + "images/d141599f75ff59081daceea801f17829-workAnniversary.png";